export const profiles = [
  {
    name: "Github",
    url: "https://github.com/sahilpaudel",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/thehighpaudel",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/sahil.paudel",
  },
  {
    name: "Twitter",
    url: "https://twitter.com/sahil_paudel",
  },
  {
    name: "Youtube",
    url: "https://youtube.com/@thehighpaudelverse?sub_confirmation=1",
  },
]
